import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { Hotkey } from 'ui-components/components/hotkey';
import { ModalService } from 'ui-components/services/modal-service';
import { ChildrenPropType } from '../../prop-types/children';

export const messages = defineMessages({
  name: {
    description: 'modalHotkey.close',
    defaultMessage: 'Close Window',
    id: '/hJrhE',
  },
});

const defaultOnClose = () => {
  ModalService.closeLastOpenModal();
};

export const hotkey = ['Escape'];
export const barcodeContent = '+9TA8HZRT5NXF=';

const CloseModalHotkey = ({ children = null, onClose = defaultOnClose }) => {
  const intl = useIntl();
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: ['Esc'],
      doNotTrack: true,
      handler: onClose,
      hotkey,
      legacyCategory: 'general',
      name: intl.formatMessage(messages.name),
    }),
    [intl, onClose],
  );

  return (
    <>
      <Hotkey hotkey={hotkeyMetadata} />
      {children}
    </>
  );
};

CloseModalHotkey.propTypes = {
  children: ChildrenPropType,
  onClose: PropTypes.func,
};

export default CloseModalHotkey;
